import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export default function MaskReveal({ children, className = "", delay = 0 }) {
  return (
    <motion.div
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, amount: 0.3 }}
      className={className}
    >
      <div className="overflow-hidden">
        <motion.div
          variants={{ hidden: { y: "110%" }, show: { y: "0%" } }}
          transition={{ duration: 0.9, ease: EASE, delay }}
        >
          {children}
        </motion.div>
      </div>
    </motion.div>
  );
}
